interface ICanculateChaseOutstandingBalance {
  insurerRefund: number;
  reclaimedInceptionDiscount: number;
  cancelFee: number;
  unusedAddOnsRefund: number;
  outstandingBalanceofFinanceAgreement: number;
  partialPaymentAmount: number;
}

const CanculateChaseOutstandingBalance = ({
  insurerRefund,
  reclaimedInceptionDiscount,
  cancelFee,
  unusedAddOnsRefund,
  outstandingBalanceofFinanceAgreement,
  partialPaymentAmount,
}: ICanculateChaseOutstandingBalance) => {
  let amount1 = insurerRefund - reclaimedInceptionDiscount - cancelFee;

  let amount2 = amount1 + unusedAddOnsRefund;
  let amount3 = Number(amount2 - outstandingBalanceofFinanceAgreement);

  let amount4 =
    amount3 < 0
      ? amount3 + (partialPaymentAmount || 0)
      : amount3 - (partialPaymentAmount || 0);

  return Number(amount4?.toFixed(2));
};

export default CanculateChaseOutstandingBalance;
